import {defaultState} from '../../state';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as UIActions from '../../../actions/UIActions';

const summaryStepView = (state = defaultState.creditoReal.ui.summaryStepView, action) => {
    switch (action.type) {
        case WizardMXActions.SET_RETURN_TO_SUMMARY.name:
            return {
                ...state,
                returnToSummary: true
            };
        case UIActions.CLEAN_STATE_ACTION.name:
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.name:
            return defaultState.creditoReal.ui.summaryStepView;
        default:
            return state;
    }
};

export default summaryStepView;